var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditBoxWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit_box_white",
    transform: "translate(-370 -376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2539",
    "data-name": "Rectangle 2539",
    transform: "translate(370 376)",
    fill: "#fff",
    stroke: "gray",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "iconfinder_728966_edit_pen_pencil_writing_draw_icon",
    d: "M17.984,2.333,16.334.683a2.334,2.334,0,0,0-3.3,0L3.017,10.7c-.455.456-1.849,2.218-1.85,2.815L0,18.667,5.15,17.5a28.427,28.427,0,0,0,2.817-1.85L17.984,5.633a2.333,2.333,0,0,0,0-3.3ZM1.547,17.121,2.3,13.774a1.157,1.157,0,0,0,.023-.145c0-.007.009-.017.011-.024l2.638,2.639-.264.16Zm5.6-2.3A11.608,11.608,0,0,1,6,15.613L2.974,12.59a10.476,10.476,0,0,1,.868-1.064l7.543-7.542,3.3,3.3ZM17.159,4.808l-1.65,1.65-3.3-3.3,1.65-1.65a1.166,1.166,0,0,1,1.65,0l1.65,1.65a1.167,1.167,0,0,1,0,1.65Z",
    transform: "translate(379 385)",
    fill: "gray"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBoxWhite);
export default __webpack_public_path__ + "static/media/edit_box_white.19126cdf3bad82e300f55564917c6d8b.svg";
export { ForwardRef as ReactComponent };